import { useEffect, useRef } from 'react';
import { MessageClass } from '@cotera/sdk/core';

const WHIMSICAL_AGENT_MESSAGES = [
  'Contacting agent',
  'Agent waking up',
  'Checking the cosmic switchboard',
  'Warming up the thinking cap',
  'Gathering sparkles of insight',
  'Polishing the crystal ball',
  'Tuning the curiosity dial',
] as const;

type ChatStatus = 'submitted' | 'streaming' | 'ready' | 'error';

type UseWhimsicalAgentMessageParams = {
  status: ChatStatus;
  messages?: MessageClass[]; // Optional, not currently used but kept for API compatibility
};

export const useWhimsicalAgentMessage = ({
  status,
}: UseWhimsicalAgentMessageParams): string | null => {
  const whimsicalMessageRef = useRef<string | null>(null);
  const shouldShowWhimsicalMessage = status === 'submitted';

  useEffect(() => {
    if (shouldShowWhimsicalMessage) {
      if (whimsicalMessageRef.current === null) {
        const randomIndex = Math.floor(
          Math.random() * WHIMSICAL_AGENT_MESSAGES.length
        );
        whimsicalMessageRef.current =
          WHIMSICAL_AGENT_MESSAGES[randomIndex] ?? null;
      }
    } else if (whimsicalMessageRef.current !== null) {
      whimsicalMessageRef.current = null;
    }
  }, [shouldShowWhimsicalMessage]);

  if (!shouldShowWhimsicalMessage) {
    return null;
  }

  return whimsicalMessageRef.current;
};
